<script>
import ActiveColumns from "../Contacts/Common/ActiveColumns.svelte";
import {External, M} from "../external";

  export let data;

  const copy = (text) => {
    External.Tools.copyToClipboard(text);
    External.Tools.showCornerMessage(1000, M.COPIED_TO_CLIPBOARD, External.Tools.TOOLTIP_TYPE_SUCCESS);
  };
</script>

<div class="col20 f-left">
  <div class="col20 f-left gray-section mb-15">
    <h3 class="col20 f-left mb-5">{M.VERIFICATION}</h3>
    <span class="col20 f-left mb-25 light-gray-text">{@html M.VERIFY_DESC}</span>
    <div class="flex align-center mb-15 col20 f-left">
      <h5 class="col2 f-left flex-none pr-20">{M.NAME}</h5>
      <div class="col18 f-left code-field"><b>@</b> {M.OR_LEAVE_BLANK}</div>
    </div>
    <div class="flex align-center mb-15 col20 f-left">
      <h5 class="col2 f-left flex-none pr-20">{M.VALUE}</h5>
      <div class="col18 f-left code-field">
        {data.identityRecord.value}
      </div>
      <a class="ml-15" on:click={() => copy(data.identityRecord.value)}>
        <span class="material-icons-outlined">content_copy</span>
      </a>
    </div>
    <!--<span class="col20 f-left light-gray-text">Explain text about the record and why it is needed</span>-->
  </div>
  <div class="col20 f-left gray-section">
    <h3 class="col20 f-left mb-5">{M.DKIM}</h3>
    <span class="col20 f-left mb-25 light-gray-text">{@html M.DKIM_DESC}</span>
    <div class="flex align-center mb-15 col20 f-left">
      <h5 class="col2 f-left flex-none pr-20">{M.NAME}</h5>
      <div class="col18 f-left code-field">
        {data.dkimRecord.key}
      </div>
      <a class="ml-15" on:click={() => copy(data.dkimRecord.key)}>
        <span class="material-icons-outlined">content_copy</span>
      </a>
    </div>
    <div class="flex align-center mb-15 col20 f-left">
      <h5 class="col2 f-left flex-none pr-20">{M.VALUE}</h5>
      <div class="col18 f-left code-field">{data.dkimRecord.value}</div>
      <a class="ml-15" on:click={() => copy(data.dkimRecord.value)}>
        <span class="material-icons-outlined">content_copy</span>
      </a>
    </div>
    <!--<span class="col20 f-left light-gray-text">Explain text about the record and why it is needed</span>-->
  </div>
</div>
